import { Injectable } from "@angular/core";
import { DocMetadataDto, DocMetadata, DocMetadataInfo, DocMetadataGroup } from "../../add-doc-metadata/model/doc-metadata";
import { DocMetadataHandler } from "../../add-doc-metadata/services/add-doc-metadata.interface";
import { AssetDocMetadata } from "../model/image-assets.model";

@Injectable()
export class ImageAssetsMetadataHandler extends DocMetadataHandler {
    assetDocMetadata!: AssetDocMetadata[];

    enableSaveMetadataChanges(): boolean {
        if ((this as any).groups == null || (this as any).groups.length == 0) return false;
        let requiredDocMetadata: DocMetadataGroup[] = (this as any).groups.filter((group: any) => group.isRequired);
        if (requiredDocMetadata.length == 0) return true;
        for (let data of requiredDocMetadata) {
            let selectedData = (this as any).selections[data.groupName];
            if (selectedData == null) return false;
            if (Array.isArray(selectedData) && selectedData.length == 0) return false;
        }
        return true;
    }

    updateClaimMetadata(newMetadata: { [key: string]: string[] }): AssetDocMetadata[] {
        let AssetDocMetadata: AssetDocMetadata[] = [];
        if (Object.keys(newMetadata)?.length) {
            let allMetadata = Object.keys(newMetadata);
            for (let metadata of allMetadata) {
                let group: DocMetadataGroup | undefined = (this as any).groups.find((group: any) => group.groupName == metadata);
                if (group) {
                    let fieldLabel = group.groupLabel;
                    let fieldName = group.groupName;
                    let values = newMetadata[metadata];
                    let groupMetadata = (this as any).docMetadataByGroup[group.groupName];
                    let fieldValues: string[] = [];
                    for (let value of values) {
                        let foundMetadata = groupMetadata.find((m: any) => m.fieldValue == value);
                        if (foundMetadata) fieldValues.push(foundMetadata.fieldLabel);
                    }
                    AssetDocMetadata.push({ fieldLabel, fieldName, fieldValues } as any);
                }
            }
        }
        return AssetDocMetadata;
    }

    override isFormControlDisabled(group: DocMetadataGroup) { return false; }

    protected initializeGroupSelections(data: DocMetadataDto, docMetadataList: DocMetadata[]): boolean {
        (this as any).selections[data.field_name] = data.is_multivalued ? [] : null;
        return false;
    }

    override extractDocMetadataInfo(data: DocMetadataDto[]): DocMetadataInfo {
        const groups: DocMetadataGroup[] = [];
        const docMetadataByGroup: {[group: string]: DocMetadata[]} = {};
        let nextId = (this as any).nextId || 1;
        data.forEach((docMetadataDto: DocMetadataDto) => {
            const lov = docMetadataDto.lov || [];
            const list: DocMetadata[] = lov.map((v: any) => new DocMetadata("", v.value_label, v.value_code, nextId++));
            (this as any).nextId = nextId;
            docMetadataByGroup[docMetadataDto.field_name] = list;
            (this as any).selections[docMetadataDto.field_name] = docMetadataDto.is_multivalued ? [] : null;
            const group: DocMetadataGroup = {
                groupName: docMetadataDto.field_name,
                isMultiValued: docMetadataDto.is_multivalued ?? false,
                groupLabel: docMetadataDto.field_label,
                hasDefaultValue: false,
                isRequired: docMetadataDto.is_required
            };
            groups.push(group);
        });
        (this as any).docMetadataByGroup = docMetadataByGroup;
        (this as any).groups = groups;
        this.setInitValuesBasedOnClaimMetadata(this.assetDocMetadata);
        return { groups, docMetadataByGroup };
    }

    private setInitValuesBasedOnClaimMetadata(assetDocMetadata: AssetDocMetadata[]) {
        if (assetDocMetadata == null || assetDocMetadata.length == 0) return;
        for (let elem of assetDocMetadata) {
            let groupMetadata: DocMetadata[] = (this as any).docMetadataByGroup[elem.fieldName];
            if (groupMetadata) {
                for (let value of elem.fieldValues) {
                    let dataToPreselect = groupMetadata.find((m) => m.fieldLabel == value || m.fieldValue == value || (m.fieldLabel && value && m.fieldLabel.toLowerCase() == value.toLowerCase()) || (m.fieldValue && value && m.fieldValue.toLowerCase() == value.toLowerCase()));
                    if (dataToPreselect == undefined) continue;
                    let metadataGroup = (this as any).groups.find((group: any) => group.groupName == elem.fieldName);
                    if (metadataGroup?.isMultiValued) {
                        if ((this as any).selections[metadataGroup.groupName] == null) {
                            (this as any).selections[metadataGroup.groupName] = [];
                        }
                        let groupSelections = (this as any).selections[metadataGroup.groupName] as DocMetadata[];
                        if (!groupSelections.find(m => m.clientId === dataToPreselect.clientId || m.fieldValue === dataToPreselect.fieldValue)) {
                            groupSelections.push(dataToPreselect);
                        }
                    } else {
                        (this as any).selections[elem.fieldName] = dataToPreselect;
                    }
                }
            }
        }
    }
}
